module.exports = __FOREMAN_VENDOR__CLASSNAMES__;